// extracted by mini-css-extract-plugin
module.exports = {"slideIn":"GuildPromotionFloatinCta_slideIn__5LC__","guildPromotionFloatinCtaSlideIn":"GuildPromotionFloatinCta_guildPromotionFloatinCtaSlideIn__UGCfR"};